// Theme context: lets nested components branch on the modern (nz) theme
// without prop-drilling through Section/Group/Card. Set once at the root
// (App.tsx) and consumed via the useIsModern() hook anywhere below.

import { createContext, useContext } from "react";

export const ThemeModernContext = createContext<boolean>(false);

export function useIsModern(): boolean {
  return useContext(ThemeModernContext);
}
